/**
 * CopyLink —— 复制链接 Unpoly 编译器组件
 *
 * 点击后将当前页面 URL 复制到剪贴板，
 * 显示 2 秒成功反馈后恢复初始状态。
 */
export class CopyLink {
  private copied = false;
  private timer: ReturnType<typeof setTimeout> | null = null;

  private btn: HTMLButtonElement;
  private iconUse: SVGUseElement | null;

  constructor(element: HTMLElement) {
    this.btn = element as HTMLButtonElement;
    this.iconUse = element.querySelector("svg use");

    this.init();
  }

  private init(): void {
    this.btn.addEventListener("click", this.handleClick);
    this.render();
  }

  private handleClick = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      this.copied = true;
      this.render();

      /* 2 秒后恢复 */
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.copied = false;
        this.render();
      }, 2000);
    } catch {
      /* 剪贴板 API 不可用时静默失败 */
    }
  };

  private render(): void {
    if (this.copied) {
      this.btn.classList.remove(
        "bg-surface-muted",
        "text-muted",
        "hover:bg-main",
        "hover:text-surface",
      );
      this.btn.classList.add(
        "bg-success-soft-bg",
        "text-success-soft-text",
        "border-success-soft-text/20",
      );
    } else {
      this.btn.classList.remove(
        "bg-success-soft-bg",
        "text-success-soft-text",
        "border-success-soft-text/20",
      );
      this.btn.classList.add(
        "bg-surface-muted",
        "text-muted",
        "hover:bg-main",
        "hover:text-surface",
      );
    }

    /* 切换图标 */
    if (this.iconUse) {
      this.iconUse.setAttribute(
        "href",
        this.copied
          ? "/public/icons.svg#icon-check"
          : "/public/icons.svg#icon-link",
      );
    }
  }

  destroy(): void {
    this.btn.removeEventListener("click", this.handleClick);
    if (this.timer) clearTimeout(this.timer);
  }

  /** 注册 Unpoly 编译器 */
  static compiler(selector: string): void {
    up.compiler(selector, (element: Element) => {
      const copyLink = new CopyLink(element as HTMLElement);
      return () => copyLink.destroy();
    });
  }
}
